!function() {
  'use strict';

  class CartBar extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('product-info');
      this.form = this.section.querySelector('[data-product-form]');
      this.formWrapper =
        (theme.settings.productPageSticky && this.section.querySelector('[data-form-wrapper]')) || this.form;
      this.submitAnchor = this.section.querySelector('[data-product-form] .product__submit') || this.section.querySelector('.product__submit');

      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
    }

    connectedCallback() {
      this.setCartBarHeight();
      this.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.addEventListener('theme:resize', this.boundToggleCartBarOnScroll);
      document.addEventListener('theme:resize', this.boundSetCartBarHeight);
      document.addEventListener('theme:product:add-error', this.handleProductAddError);
      this.toggleCartBarOnScroll();
    }

    getStickyHeaderOffset() {
      if (!document.body.classList.contains('has-header-sticky')) return 0;

      if (typeof window.theme.readHeights === 'function') {
        const { headerHeight } = window.theme.readHeights();
        return headerHeight || 0;
      }

      return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')) || 0;
    }

    toggleCartBarOnScroll() {
      if (!this.submitAnchor) {
        this.classList.remove('is-visible');
        return;
      }

      const rect = this.submitAnchor.getBoundingClientRect();
      const headerOffset = this.getStickyHeaderOffset();
      const isPastSubmit = rect.bottom <= headerOffset + 1;

      // show the bar on the first scroll (not only after the main button leaves the screen)
      this.classList.toggle('is-visible', isPastSubmit || window.scrollY > 40);
    }

    handleClick(event) {
      const addButton = event.target.closest('[data-cart-bar-add-to-cart]');

      if (addButton) {
        event.preventDefault();
        addButton.classList.add('is-loading');
        addButton.setAttribute('disabled', 'disabled');
        this.form.closest('product-form').onSubmitHandler(event);
      }

      if (event.target.closest('[data-cart-bar-scroll]')) {
        event.preventDefault();
        this.scrollToTop();
      }
    }

    handleProductAddError() {
      if (this.querySelector('[data-cart-bar-add-to-cart]')) {
        this.scrollToTop();
      }
    }

    scrollToTop() {
      const variantSelects = this.section.querySelector('variant-selects');
      const target = this.submitAnchor || variantSelects || this.form;
      const top = target.getBoundingClientRect().top;

      window.theme.scrollTo(theme.isMobile ? top - 10 : top);
    }

    setCartBarHeight() {
      document.documentElement.style.setProperty('--cart-bar-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:product:add-error', this.handleProductAddError);
      document.removeEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.removeEventListener('theme:resize', this.boundToggleCartBarOnScroll);
      document.removeEventListener('theme:resize', this.boundSetCartBarHeight);
    }
  }

  // solid #6c6948 button on the sticky bar (same colour as the main Add to Cart)
  if (!document.getElementById('cart-bar-button-style')) {
    const style = document.createElement('style');
    style.id = 'cart-bar-button-style';
    style.textContent = '.cart-bar .product__submit__add{background-color:#6c6948!important;border-color:#6c6948!important;color:#fff!important}';
    document.head.appendChild(style);
  }

  if (!customElements.get('cart-bar')) {
    customElements.define('cart-bar', CartBar);
  }
}();
